import { InfiniteData } from '@tanstack/query-core';
import { useMutation } from '@tanstack/react-query';
import type { PaginatedList } from '@shared/types/common';
import type { ExerciseVideo } from '@shared/types/exercises';
import { API } from '@src/api/index.ts';
import { queryClient } from '@src/api/query-client.ts';
import { EntityByIdParam } from '@src/api/types.ts';

export const useDeleteExerciseMutation = () => {
  return useMutation({
    mutationFn: async (params: EntityByIdParam) => await API.exercises.delete(params),
    onSuccess: (response, { id }) => {
      queryClient.setQueriesData(
        { queryKey: ['exercises'] },
        (oldData: InfiniteData<PaginatedList<ExerciseVideo>>) => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            pages: oldData.pages.map((page) => ({
              ...page,
              results: [...page.results.filter((item) => item.id !== Number(id))],
            })),
          };
        }
      );

      queryClient.invalidateQueries({ queryKey: ['exercises'] });
    },
  });
};
